import { theme } from '../../../../theme';

/**
 * Styles for FeedDrawer component
 */
export const drawerStyles = {
  display: 'flex',
  width: '768px',
  height:'stretch',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '12px',
  borderLeft: '10px solid var(--Navy---navy-main, #061E44)',
  background: 'var(--Greyscale-white, #FFF)',
};

export const drawerContentStyles = {
  width: '100%',
  height: '100%',
  padding: '12px',
  boxSizing: 'border-box',
};

export const exportButtonStyles = {
  display: 'flex',
  padding: '7px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flex: '1 0 0',
  alignSelf: 'stretch',
  borderRadius: '100px !important',
  border: `1px solid ${theme.palette.colors.bluePrimaryMain}`,
  background: 'var(--Greyscale-white, #FFF)',
  textTransform: 'none',
};

export const exportButtonTypographyStyles = {
  color: theme.palette.colors.bluePrimaryMain,
  textAlign: 'center',
  textTransform: 'none',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: '0.32px',
};

